import type { WaitingOrder } from '@myrewards/contracts';
import { useQuery } from '@tanstack/react-query';
import { mySettingsQuery } from '../api';

/**
 * The order Waiting on you opens in (APP-149 D7): the person's choice in My preferences, oldest
 * first until they make one or while it can't be read. Home's loader reads it first, so Home
 * opens in it every time; a sort made on the card lasts while Home is open (B5).
 */
export function useWaitingOrder(): WaitingOrder {
  return useQuery(mySettingsQuery).data?.waitingOrder ?? 'oldest';
}
